import * as React from "react";

export const MascotSmall1 = (props: any) => (
  <svg
    width={52}
    height={52}
    viewBox="4 4 44 44"
    fill="#E48A99"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#a)">
      <path
        d="M26 48c12.15 0 22-9.85 22-22S38.15 4 26 4 4 13.85 4 26s9.85 22 22 22Z"
        fill="#fff"
      />
      <path
        d="M26 48c12.15 0 22-9.85 22-22S38.15 4 26 4 4 13.85 4 26s9.85 22 22 22Z"
        opacity={0.15}
      />
      <path d="M23.765 9.074c-4.579.813-5.787 7.836-5.764 10.158a6.61 6.61 0 0 0 .837 3.214 7.453 7.453 0 0 0 2.345 2.543v11.22l-2.788 1.188a.815.815 0 0 0-.364.457.73.73 0 0 0 .057.558.862.862 0 0 0 .449.39c.197.078.418.09.624.034l5.368-1.376a.746.746 0 0 0 .39-.13.629.629 0 0 0 .238-.308c.043-.27-.3-.634-.837-.625v-10.1a9.051 9.051 0 0 0 3.417.013V40.34l-2.789 1.187a.815.815 0 0 0-.364.457.73.73 0 0 0 .057.559.862.862 0 0 0 .45.39c.197.078.419.09.624.033l5.369-1.376a.746.746 0 0 0 .39-.13.628.628 0 0 0 .237-.308c.043-.27-.3-.634-.838-.625V25.037c1.386-.9 2.402-2.184 2.892-3.654a6.626 6.626 0 0 0-.45-4.68c-1.307-3.21-5.295-8.384-9.55-7.629Zm-3.589 9.258.043-.686 4.5-4.048.689-.03.717.413 1.63 5.516-.329.56-.722.328-6.139-1.492-.389-.561Z" />
      <path d="M24.393 18.828c1.078 0 1.952-.783 1.952-1.75s-.874-1.75-1.952-1.75c-1.078 0-1.952.783-1.952 1.75s.874 1.75 1.952 1.75Z" />
    </g>
    <defs>
      <filter
        id="a"
        x={0}
        y={0}
        width={52}
        height={52}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values="0 0 0 0 0.362353 0 0 0 0 0.418353 0 0 0 0 0.54902 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_74_24538"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_74_24538"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
